import type {
  HotelRoomingListApi,
  HotelRoomingListGuestApi,
} from '@revolugo/booking-api-client'
import type { HotelRoomingListGuestResponseDto } from '@revolugo/graphql/private'

export class HotelRoomingListGuestAdapter {
  public hotelRoomingListGuest: HotelRoomingListGuestApi
  public hotelRoomingListId: HotelRoomingListApi['id']

  constructor(
    hotelRoomingListGuest: HotelRoomingListGuestApi,
    hotelRoomingListId: HotelRoomingListApi['id'],
  ) {
    this.hotelRoomingListGuest = hotelRoomingListGuest
    this.hotelRoomingListId = hotelRoomingListId
  }

  public toHotelRoomingListGuest(): Omit<
    HotelRoomingListGuestResponseDto,
    'createdAt' | 'updatedAt'
  > {
    return {
      __typename: 'HotelRoomingListGuestResponseDto',
      ...this.hotelRoomingListGuest,
      hotelRoomingListId: this.hotelRoomingListId,
    }
  }
}
